//TODO: temporary
const SYMBOLS = {
  GBP: '£',
  EUR: '€',
  USD: '$',
  NZL: 'NZ$',
  CHN: '¥',
  CAD: 'CA$',
  AUS: '$',
  CHF: 'Fr',
};

export const getSymbol = (i: string): string => SYMBOLS[i] || i;
